import axios from "axios";
import qs from "qs";

import AuthManager from "./auth";
import ReduxStore from "./redux";
import { authExpired } from "./redux/user";


// Required for some reason
axios.defaults.headers = {
  accept: "*/*",
};

axios.defaults.paramsSerializer = (params) => {
  const str = qs.stringify(params, { encode: false, arrayFormat: "brackets" });
  // add custom replace for brackets
  return str.replace(/={}/g, "{}");
};

export const REACT_APP_ENV = process.env.NODE_ENV !== "production" ? "staging" : "production";

const SAMARITAN_DOMAIN = process.env.REACT_APP_SAMARITAN_DOMAIN;
const SAMARITAN_DEV_URL = process.env.REACT_APP_SAMARITAN_DEV_URL;

let SAMARITAN_URL = "";

if (SAMARITAN_DEV_URL) {
  SAMARITAN_URL = SAMARITAN_DEV_URL;
} else if (SAMARITAN_DOMAIN) {
  SAMARITAN_URL = `https://www.${SAMARITAN_DOMAIN}`;
} else if (process.env.NODE_ENV === "development") {
  SAMARITAN_URL = "https://staging.samaritan.city";
} else {
  SAMARITAN_URL = "https://www.samaritan.city";
}

console.log("REACT_APP_ENV", REACT_APP_ENV);
console.log("SAMARITAN_URL", SAMARITAN_URL);

/**
 * Method tells redux that an authenticated session is expired
 */
const errorAuthInterceptor = (error) => {
  if (error.response.status === 401) {
    ReduxStore.dispatch(authExpired());
  }
  return Promise.reject(error);
};

const member = axios.create({
  baseURL: "",
});

member.interceptors.request.use((config) => ({
  ...config,
  headers: {
    SESSION_TOKEN: `${AuthManager.sessionToken}`,
    Authorization: `Token token=${AuthManager.apiToken}`,
    ...config.headers
  },
}));

member.interceptors.response.use(undefined, errorAuthInterceptor);

const memberLogin = axios.create({
  baseURL: "",
});

const v3 = axios.create({
  baseURL: "",
});

v3.interceptors.request.use((config) => ({
  ...config,
  headers: {
    Authorization: `Token token=${AuthManager.apiToken}`,
    ...config.headers
  },
}));

v3.interceptors.response.use(undefined, errorAuthInterceptor);

export const updateBaseURLs = (newURL) => {
  console.log("setting SAMARITAN_URL:", newURL)
  memberLogin.defaults.baseURL  = `${newURL}/members/api`;
  member.defaults.baseURL  = `${newURL}/members/api`;
  v3.defaults.baseURL  = `${newURL}/api/v3`;
}

// set initial values
updateBaseURLs(SAMARITAN_URL);

const v2 = axios.create({
  baseURL: `${SAMARITAN_URL}/api/v2`,
});

v2.interceptors.request.use((config) => ({
  ...config,
  params: {
    SESSION_TOKEN: AuthManager.sessionToken,
    ...config.params,
  },
}));

const HttpClient = {
  v2,
  v3,
  member,
  memberLogin
};

export default HttpClient;
export { SAMARITAN_URL };
